






























































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

interface IConfirm {
  resolve?: (() => void) | null;
  reject?: (() => void) | null;
}


@Component({
  components: {}
})
export default class VaultAdminView extends Vue {

  private static getCombinations(value: string): string[] {
    if (value !== '') {
      return [value.toUpperCase(), value.toLowerCase()];
    }
    return [''];
  }

  private lookupUsername: string = '';
  private lookupEmail: string = '';

  private resetEmail: string = '';

  private deleteUsername: string = '';
  private deleteEmail: string = '';

  private renameCurrentUsername: string = '';
  private renameNewUsername: string = '';

  private isConfirmModalOpen: boolean = false;
  private isLoading: boolean = false;
  private results: object[] = [];
  private confirm: IConfirm = {
    resolve: null,
    reject: null
  };

  /**
   * Lookup a username/email combination on the server.
   * Try out all uppercase/lowercase combinations.
   */
  protected async lookupUser() {
    if (this.lookupUsername === '' && this.lookupEmail === '') {
      return this.$notify({type: 'warning', text: 'Either username or email is required to lookup.'});
    }
    this.results = [];
    this.isLoading = true;
    const usernames = VaultAdminView.getCombinations(this.lookupUsername);
    const emails = VaultAdminView.getCombinations(this.lookupEmail);
    for (const username of usernames) {
      for (const email of emails) {
        const response = await axios.post('admin/vault/lookup', {username, email});
        const result = response.data;
        if (result.username || result.email) {
          const resultRow: any = {};
          resultRow.username = username;
          resultRow.email = email;
          resultRow.emailFound = result.email;
          resultRow.usernameFound = result.username;

          if (resultRow.emailFound && resultRow.usernameFound) {
            resultRow.link = {
              color: result.linked ? 'green' : 'red',
              message: result.linked ? 'Username and Email are linked' : 'Username and Email are not linked'
            };
          } else {
            resultRow.link = {
              color: 'yellow',
              message: 'Link status is unknown.'
            };
          }
          this.results.push(resultRow);
        }
      }
    }
    if (this.results.length === 0) {
      this.results.push({
        username: this.lookupUsername,
        email: this.lookupEmail,
        isNotFound: true,
        link: {
          color: null,
          message: 'Could not find record'
        }
      });
    }
    this.isLoading = false;
  }

  /**
   * Reset the password of a user.
   */
  protected async resetPassword() {
    if (this.resetEmail === '') {
      return this.$notify({type: 'warning', text: 'Email address is required to reset password.'});
    }
    this.isLoading = true;
    try {
      await new Promise((resolve, reject) => {
        this.confirm = { resolve, reject };
        this.isConfirmModalOpen = true;
      });

      try {
        await axios.post('admin/vault/reset-password', { email: this.resetEmail });
        this.$notify({
          type: 'success',
          text: `The user's password has been reset and the new password has been sent to ${this.resetEmail}.`
        });
      } catch (e) {
        console.error(e);
        this.$notify({type: 'error', text: e.message});
      }
    } catch (e) {
      // ignored
    }
    this.resetEmail = '';
    this.isLoading = false;
  }

  /**
   * Purge all records of a user from Vault.
   */
  protected async deleteUserData() {
    if (this.deleteEmail === '' || this.deleteUsername === '') {
      return this.$notify({
        type: 'warning',
        text: 'Email address and username is required to delete user.'
      });
    }
    this.isLoading = true;
    this.isLoading = true;
    try {
      await new Promise((resolve, reject) => {
        this.confirm = { resolve, reject };
        this.isConfirmModalOpen = true;
      });
      try {
        await axios.post('admin/vault/delete', { email: this.deleteEmail, username: this.deleteUsername });
        this.$notify({
          type: 'success',
          text: `The user's data has been purged from Vault.`
        });
      } catch (e) {
        if (e.response.status === 404) {
          this.$notify({
            type: 'error',
            text: 'The username or email could not be found.'
          });
        } else if (e.response.status === 409) {
          this.$notify({
            type: 'error',
            text: 'The username and email are not linked to each other and hence cannot be deleted.'
          });
        } else {
          console.error(e);
          this.$notify({ type: 'error',  text: e.message });
        }
      }
    } catch (e) {
      // ignored
    }
    this.deleteEmail = this.deleteUsername = '';
    this.isLoading = false;
  }

  protected async renameUsername() {
    if (this.renameCurrentUsername === '' || this.renameNewUsername === '') {
      return this.$notify({
        type: 'warning',
        text: 'Current username and new username is required.'
      });
    }

    this.isLoading = true;
    this.isLoading = true;
    try {
      await new Promise((resolve, reject) => {
        this.confirm = { resolve, reject };
        this.isConfirmModalOpen = true;
      });
      try {
        await axios.post('admin/vault/rename-username', {
          username: this.renameCurrentUsername,
          newUsername: this.renameNewUsername
        });
        this.$notify({
          type: 'success',
          text: `The username has been changed.`
        });
      } catch (e) {
        if (e.response.status === 404) {
          this.$notify({
            type: 'error',
            text: 'The username could not be found.'
          });
        } else if (e.response.status === 409) {
          this.$notify({
            type: 'error',
            text: 'The new username already exists.'
          });
        } else {
          console.error(e);
          this.$notify({ type: 'error',  text: e.message });
        }
      }
    } catch (e) {
      // ignored
    }
    this.renameNewUsername = this.renameCurrentUsername = '';
    this.isLoading = false;

  }

  protected doConfirmation() {
    this.isConfirmModalOpen = false;
    if (this.confirm.resolve) {
      this.confirm.resolve();
      this.confirm.resolve = this.confirm.reject = null;
    }
  }

  protected dismissConfirmation() {
    this.isConfirmModalOpen = false;
    if (this.confirm.reject) {
      this.confirm.reject();
      this.confirm.resolve = this.confirm.reject = null;
    }
  }
}
